export const getSupportedMimeType = (): string | undefined => {
  const possibleTypes = ["audio/webm; codecs=opus"];
  return (
    possibleTypes.find((type) => MediaRecorder.isTypeSupported(type)) ||
    undefined
  );
};

export const getSafeAudioConstraints = (
  requested: MediaTrackConstraints = {},
): MediaTrackConstraints => {
  const supported = navigator.mediaDevices?.getSupportedConstraints?.() ?? {};
  const cleaned: MediaTrackConstraints = {};
  if (supported.autoGainControl && requested.autoGainControl != undefined) {
    cleaned.autoGainControl = requested.autoGainControl;
  }
  if (supported.echoCancellation && requested.echoCancellation != undefined) {
    cleaned.echoCancellation = requested.echoCancellation;
  }
  if (supported.noiseSuppression && requested.noiseSuppression != undefined) {
    cleaned.noiseSuppression = requested.noiseSuppression;
  }
  console.log(cleaned);
  return cleaned;
};
